import { ExperimentVariation, GBFadeInExperiment } from '@/experimentation'
import { BoxOfficeFilm, BoxOfficeRail } from '@/organisms/BoxOfficeRail'
import { isHasTypeName } from '@/services/RenderService'
import { Header as HeaderType } from '@/types/codegen-contentful'

export function isHeader(content: unknown): content is HeaderType {
  return isHasTypeName(content) && content.__typename === 'Header'
}

/** The collection ID used by the Box Office Rail */
const BOX_OFFICE_COLLECTION_ID = '5c7ee724-4deb-4588-9850-e7fe305501cf'

interface HeaderProps {
  header: HeaderType
  testId: string
  /** Pre-fetched box office films keyed by collection ID */
  boxOfficeFilms?: Record<string, BoxOfficeFilm[]>
}
export function Header(props: HeaderProps) {
  const Level = `${props.header.level ?? 'h2'}` as keyof JSX.IntrinsicElements
  const size = props.header.size ?? 'text-2xl'
  const color = props.header.color ?? 'text-white'
  const align = props.header.align ?? 'text-left'
  const newReleasesId = '7kdYlmOQParCYfeKJHasV2'
  const initialFilms = props.boxOfficeFilms?.[BOX_OFFICE_COLLECTION_ID]
  return (
    <>
      {props.testId === newReleasesId ? (
        <GBFadeInExperiment experimentName="box-office-hits-rail" defaultValue={'control'}>
          <ExperimentVariation variation={'variation_1'}>
            <BoxOfficeRail
              title="From The Big Screen"
              collectionId={BOX_OFFICE_COLLECTION_ID}
              initialFilms={initialFilms}
            />
          </ExperimentVariation>
          <ExperimentVariation variation={'variation_2'}>
            <BoxOfficeRail
              title="From The Big Screen"
              collectionId={BOX_OFFICE_COLLECTION_ID}
              initialFilms={initialFilms}
              hideBoxOffice
            />
          </ExperimentVariation>
          <ExperimentVariation variation={'control'}>{null}</ExperimentVariation>
        </GBFadeInExperiment>
      ) : null}
      <header className="relative">
        <Level
          className={`${size} ${color} ${align} m-0 p-0 font-whitney font-bold !leading-[1.25] -tracking-[0.01em]`}
        >
          {props.header.headerText}
        </Level>
      </header>
    </>
  )
}
